import policyConfigJson from '../dictionary/policyConfig.json';

const getConfig = (path: string): boolean => {
  return policyConfigJson[path];
};

export default getConfig;
